module.exports = __webpack_public_path__ + "static/img/img_title_11_2.5723a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_11_2.png
// module id = 561
// module chunks = 1